<template>
  <button type="button" class="print-button" :disabled="busy" @click="download">
    <i class="fas fa-file-pdf" aria-hidden="true"></i> {{ busy ? 'Generating CV…' : 'Download CV (PDF)' }}
  </button>
</template>
<script>
import { downloadCv } from '../cv-pdf'

export default {
  name: 'PrintButton',
  data() { return { busy: false } },
  methods: {
    // Genera un PDF en formato CV (A4) con los datos de cv-data.js; no imprime la pagina web.
    async download() {
      this.busy = true
      try {
        await downloadCv()
      } catch (e) {
        console.error(e)
        window.alert('The CV could not be generated. Please try again.')
      } finally {
        this.busy = false
      }
    }
  }
}
</script>
<style scoped>
.print-button {
  margin-top: 18px;
  padding: 10px 22px;
  font-weight: 700;
  color: #fff;
  background: transparent;
  border: 2px solid #fff;
  border-radius: 4px;
  cursor: pointer;
}
.print-button:hover:not(:disabled), .print-button:focus-visible { background: #fff; color: #222; }
.print-button:disabled { opacity: .6; cursor: progress; }
</style>
